export default __webpack_public_path__ + "static/media/discordview.5bbdbd05.png";